import { PATHNAMES } from '@core/types/pathnames';

export const generateLocalizedPathnames = (
  locales: (keyof typeof PATHNAMES)[]
): Record<string, string | Record<string, string>> =>
  Object.entries(PATHNAMES.default).reduce(
    (acc, [key, defaultPath]) => {
      const localizedPaths = locales.reduce<Record<string, string>>(
        (localeAcc, locale) => ({
          ...localeAcc,
          [locale]:
            PATHNAMES[locale]?.[key as keyof typeof PATHNAMES.default] ??
            defaultPath,
        }),
        {}
      );

      acc[defaultPath] =
        Object.keys(localizedPaths).length === 1 ? defaultPath : localizedPaths;
      return acc;
    },
    {} as Record<string, string | Record<string, string>>
  );
